function addReadMore(element) {
    if (element) {
        const previewHeight = 300;
        if (element.scrollHeight > previewHeight) {
            if (!element) {
                //if there is no text to collapse, abort the accordion script
                return false;
            }
            const realHeight = element.scrollHeight;
            element.setAttribute('data-height', realHeight + 'px');
            element.style.height = previewHeight + 'px';

            // Creating a fade div element
            const divElement = document.createElement('Div');
            divElement.classList.add('titleTextFadeDiv');
            element.appendChild(divElement);

            // Create button
            const buttonElement = document.createElement('Button');
            buttonElement.className = 'readMoreButton';
            //buttonElement.className = 'more';
            buttonElement.innerHTML = 'Read More';
            element.appendChild(buttonElement);

            // Add Click handler
            buttonElement.onclick = function () {
                //if open, then collapse
                if (element.classList.contains('seo-collapse')) {
                    element.classList.remove('seo-collapse');
                    element.style.height = previewHeight + 'px';
                    buttonElement.innerHTML = 'Read More';
                    buttonElement.classList.remove('readLessButton');
                    return false;
                }
                //if collapsed, then open
                element.classList.remove('seo-collapse');
                element.style.height = previewHeight + 'px';
                element.classList.add('seo-collapse');
                element.style.height = 'auto';
                buttonElement.innerHTML = 'Read Less';
                buttonElement.classList.add('readLessButton');
                return false;
            };
        }
    }
}

export default addReadMore;
